import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.row.created_at), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.row.user_id), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.row.type), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.getAmount(_ctx.row)), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.getWallet(_ctx.row)), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.row.status), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('cell'))
    }, [
      _createElementVNode("p", {
        class: _normalizeClass(_ctx.b('row-label'))
      }, _toDisplayString(_ctx.getMessage(_ctx.row)), 3)
    ], 2)
  ], 2))
}